module.exports = __webpack_public_path__ + "static/media/img5.6c741055.jpg";